import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { defineComponent, reactive, toRefs, onMounted, watch, computed } from '@vue/composition-api';
import { sendLog, immediateSendLog, webLogger } from '@/common/log';
import { isAndroid } from '@/common/device-info';
import { callApp } from '@/common/call-app';
import { appName } from '@/common/const';
import imageBox from '@/components/image-box/index.vue';
import { getLocale } from '@/config/language';
import { getMessagesById } from '../share/invitation/model';
import shareModel from './models/share';
import ProgressText from './components/progress-text/index.vue';
import Progress from './components/progress/index.vue';
import Button from './components/button/index.vue';
import CountDown from './components/timerCountDown/index.vue';
import ActivityOver from './components/activityOver/index.vue';
export default defineComponent({
  name: 'freebuy-share',
  components: {
    imageBox: imageBox,
    ProgressText: ProgressText,
    Progress: Progress,
    Button: Button,
    CountDown: CountDown,
    ActivityOver: ActivityOver
  },
  setup: function setup(_, ctx) {
    var _share_id$toString$sp;

    var state = reactive({
      finished: false,
      title: '',
      canAssistTitle: '',
      canAssistDesc: '',
      backgroundImage: '',
      assistButton: ''
    });
    var _ctx$root$$route$quer = ctx.root.$route.query,
        groupId = _ctx$root$$route$quer.groupId,
        cc = _ctx$root$$route$quer.cc,
        activity = _ctx$root$$route$quer.activity,
        fishId = _ctx$root$$route$quer.fishId,
        share_id = _ctx$root$$route$quer.share_id,
        sourcePlatform = _ctx$root$$route$quer.sourcePlatform,
        countryName = _ctx$root$$route$quer.countryInfo,
        share_uid = _ctx$root$$route$quer.share_uid,
        userId = _ctx$root$$route$quer.userId,
        share_item_type = _ctx$root$$route$quer.share_item_type,
        share_device_id = _ctx$root$$route$quer.share_device_id,
        language = _ctx$root$$route$quer.language;
    var userID = userId || share_uid;
    var country = Array.isArray(countryName) ? countryName[0] : countryName;
    var shareIds = (_share_id$toString$sp = share_id === null || share_id === void 0 ? void 0 : share_id.toString().split('_')) !== null && _share_id$toString$sp !== void 0 ? _share_id$toString$sp : [];
    immediateSendLog({
      type: 'pv',
      name: 'FREE_BUY_OUT_H5',
      value: {
        type: isAndroid ? 'ANDROID' : 'IOS',
        share_channel: cc,
        share_activity: activity,
        share_id: share_id,
        fish_id: fishId,
        ua: window.navigator.userAgent,
        source_platform: sourcePlatform,
        share_item_info: 'refferalactivitydefault',
        share_uid: userID,
        share_item_type: share_item_type,
        share_timestamp: shareIds[(shareIds === null || shareIds === void 0 ? void 0 : shareIds.length) - 1],
        share_device_id: share_device_id,
        isBusinessCoreLog: true
      }
    });

    var _shareModel = shareModel({
      groupId: groupId
    }),
        initData = _shareModel.initData,
        commodityImage = _shareModel.commodityImage,
        freeBuyInfo = _shareModel.freeBuyInfo,
        _shareModel$userInfo = _shareModel.userInfo,
        userInfo = _shareModel$userInfo === void 0 ? {} : _shareModel$userInfo,
        isNormal = _shareModel.isNormal,
        commodityInfo = _shareModel.commodityInfo;

    var onFinish = function onFinish() {
      state.finished = true;
    };

    var onGroup = computed(function () {
      var _freeBuyInfo$value, _commodityInfo$value;

      return ((_freeBuyInfo$value = freeBuyInfo.value) === null || _freeBuyInfo$value === void 0 ? void 0 : _freeBuyInfo$value.status) === 1 && ((_commodityInfo$value = commodityInfo.value) === null || _commodityInfo$value === void 0 ? void 0 : _commodityInfo$value.status) === 1;
    });
    var isSnack = appName === 'snack';

    var handleClick = function handleClick() {
      if (isNormal.value) {
        sendLog({
          type: 'click',
          name: 'FREE_BUY_OUT_H5_BUTTON',
          value: {
            isBusinessCoreLog: true
          }
        });
      } else {
        sendLog({
          type: 'click',
          name: 'EXCEPTION_STATUS'
        });
      }

      var query = {
        groupId: groupId,
        webview: 'yoda',
        showLoading: 'true',
        needLogin: 'true',
        need_login: 'true',
        source: 'out',
        share_channel: cc,
        hyId: 'incentive_main',
        countryInfo: country,
        loginCheck: 1,
        __login_params__: JSON.stringify({
          scheme: 'ikwai://login',
          loginType: 1
        }),
        __launch_options__: JSON.stringify({
          topBarPosition: 'fixed',
          enableLoading: true,
          loadingType: 'incentive_h5'
        })
      };

      if (isSnack) {
        query = _objectSpread(_objectSpread({}, query), {}, {
          hideNavBar: 1
        });
      }

      var search = Object.entries(query).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return "".concat(key, "=").concat(encodeURIComponent(value));
      }).join('&');
      var url = "".concat(window.location.origin, "/freebuy/list?").concat(search);
      var protocol = isSnack ? 'ikwaibulldog' : 'ikwai';
      var onlink = {
        me: 'https://kwaimereferral.onelink.me/JFE0/forfree',
        pro: 'https://go.onelink.me/iGO2/forfree',
        snack: 'https://go.onelink.me/kQdi/forfree'
      };
      var afSub1 = JSON.stringify({
        share_id: share_id,
        shareInfo: {
          target_url: location.href
        }
      });
      callApp({
        // 拉活归因链路中必需参数 调起客户端时 客户端会检测链接中是否有target_url参数
        path: "webview?url=".concat(encodeURIComponent(url), "&target_url=").concat(encodeURIComponent(location.href)),
        onelink: "".concat(onlink[appName], "?af_sub1=").concat(encodeURIComponent(afSub1)),
        protocol: protocol
      });
    };

    var getPreivewMessage = function getPreivewMessage(name) {
      var pageMap = {
        '/activity/invite-share': 'inviteShare',
        '/activity/share-invitation': 'inviteShare',
        '/activity/boost-share-invitation': 'landing',
        '/activity/child-share-invitation': 'childShare',
        '/freebuy/share': 'freebuy'
      };
      var search = new URLSearchParams(location.search);
      var messageName = pageMap[name];
      var messageStr = decodeURIComponent(search.get(messageName));

      try {
        var message = JSON.parse(messageStr);
        return message || {};
      } catch (error) {
        return {};
      }
    };

    var initPreviewPage = function initPreviewPage() {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var previewPage = ['/activity/boost-share-invitation', '/activity/share-invitation', '/activity/invite-share', '/freebuy/share'];
      var previewMessage;

      if (previewPage.includes(location.pathname)) {
        previewMessage = getPreivewMessage(location.pathname);
        messages = Object.assign(messages, previewMessage);
      }

      return {
        freebuy: messages
      };
    }; // 获取落地页样式和素材


    var getShareMessages = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var messagesRes, _webLogger$plugins, _webLogger$plugins$ra;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                messagesRes = {};

                if (!(fishId && /^\d+$/.test(String(fishId)))) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return getMessagesById({
                  fishId: Number(fishId),
                  language: getLocale(),
                  pageName: 'freebuy'
                });

              case 4:
                messagesRes = _context.sent;

              case 5:
                try {
                  webLogger === null || webLogger === void 0 ? void 0 : (_webLogger$plugins = webLogger.plugins) === null || _webLogger$plugins === void 0 ? void 0 : (_webLogger$plugins$ra = _webLogger$plugins.radar) === null || _webLogger$plugins$ra === void 0 ? void 0 : _webLogger$plugins$ra.fmp();
                } catch (error) {
                  console.error(error);
                }

                messagesRes = initPreviewPage(messagesRes.freebuy);
                state.title = messagesRes.freebuy.title;
                state.backgroundImage = messagesRes.freebuy.backgroundImage;
                state.canAssistTitle = messagesRes.freebuy.canAssistTitle;
                state.canAssistDesc = messagesRes.freebuy.canAssistDesc;
                state.assistButton = messagesRes.freebuy.assistButton || ctx.root.$k18n('open Kwai');
                document.title = state.title || ctx.root.$k18n('Take it for free');

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getShareMessages() {
        return _ref3.apply(this, arguments);
      };
    }();

    watch(function () {
      return isNormal.value;
    }, function (val) {
      if (!val) {
        sendLog({
          type: 'show',
          name: 'EXCEPTION_STATUS',
          value: {
            isBusinessCoreLog: true
          }
        });
      }
    }, {
      immediate: true
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return initData();

            case 3:
              _context2.next = 5;
              return getShareMessages();

            case 5:
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              isNormal.value = false;
              console.log(_context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    })));
    return _objectSpread(_objectSpread({}, toRefs(state)), {}, {
      commodityImage: commodityImage,
      freeBuyInfo: freeBuyInfo,
      userInfo: userInfo,
      onFinish: onFinish,
      handleClick: handleClick,
      isNormal: isNormal,
      onGroup: onGroup
    });
  }
});